import { render } from "./Setting.vue?vue&type=template&id=458976f0&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-458976f0"

export default script